import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Accordion,
  AccordionSummary,
  Typography,
  CardHeader,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../components/Button';
import ContentProfileComponent from './components/ContentProfileComponent';
import ReviewsProfileComponent from './components/ReviewsProfileComponent';
import LocationsProfileComponent from './components/LocationsProfileComponent';
import SpecialtiesProfileComponent from './components/SpecialtiesProfileComponent';
import InsurancesProfileComponent from './components/InsurancesProfileComponent';
import ProfileEditModal from './components/ProfileEditModal';
import ProviderConsultOptionInsert from './components/ProviderConsultOptionInsert';
import ProfileInsertModal from './components/ProfileInsertModal';
import FAQsList from './components/FAQsList';
import FAQcreatOrEditeModal from './components/FAQcreatOrEditeModal';
import CropModal from './components/CropModal';
import NoticeDialog from '../../components/DialogModals/NoticeDialog';
import Avatar from '../../components/Avatar';
import './style.css';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import {
  fetchProviderByUrl,
  updateProvider,
  getFileReq,
  setFileReq,
  fetchProviderPreferredInfo,
} from '../../services/api';
import * as adminApi from '../../services/api/admin';
import * as authApi from '../../services/api/auth';
import * as api from '../../services/api/index';

const { fileSelectHandler } = require('../../util/fileHandling');

function ProviderProfileMain(props) {
  const {
    classes: {
      cardSection,
      headerText,
      container,
      fullWidth,
      newFaqButton,
      hidden,
      input,
      columnRadSec,
    },
  } = props;

  // const availableSections = ['about', 'credentials-research', 'faq'];
  const availableSections = ['about', 'credentials-research'];
  const availableCategories = ['video', 'image', 'text', 'link'];
  const availableCategoriesForCredentialsResearch = ['text', 'link'];
  const [providerInUrl, setProviderInUrl] = useState({});
  const [providerInfo, setProviderInfo] = useState('');
  const [providersContents, setProvidersContents] = useState([]);
  const [openEditModal, setOpenEditModal] = useState({
    bool: false,
    section: '',
  });
  const [openInsertModal, setOpenInsertModal] = useState({
    bool: false,
    section: '',
    category: '',
  });
  const [providerFaqs, setProviderFaqs] = useState([]);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [editProviderConsult, setEditProviderConsult] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [FaqModalMode, setFaqModalMode] = useState('create'); // "create" or "edit"
  const [editFaqFaqId, setEditFaqFaqId] = useState();
  const [profileImg, setProfileImg] = useState();
  const [crop, setCrop] = useState({ width: 100, aspect: 1 / 1, x: 0, y: 0 });
  const [cropModal, setCropModal] = useState(false);
  const [cropImg, setCropImg] = useState();
  const [popNotice, setPopNotice] = useState('');

  useEffect(() => {
    (async () => {
      const curUser = await authApi.fetchCurrentUser();
      setCurrentUser(curUser);
      if (curUser.provider.providerUrl) {
        const providerByUrl = await fetchProviderByUrl(
          curUser.provider.providerUrl
        );
        setProviderInUrl(providerByUrl);
        const contents = await adminApi.fetchContentsByProviderId(
          providerByUrl.id
        );
        setProvidersContents(contents);
      }
      const faqs = await adminApi.getFAQsReq(curUser.provider.id);
      setProviderFaqs(faqs);
      // fetchProviderPreferredDetails();
      if (curUser.provider) {
        const providerDetails = await fetchProviderPreferredInfo(
          curUser.provider.id
        );
        setProviderInfo(providerDetails);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (providerInUrl.id) {
        const contents = await adminApi.fetchContentsByProviderId(
          providerInUrl.id
        );
        setProvidersContents(contents);
      }
      if (currentUser.provider) {
        const providerDetails = await fetchProviderPreferredInfo(
          currentUser.provider.id
        );
        setProviderInfo(providerDetails);
      }
    })();
  }, [openInsertModal, editProviderConsult]);

  const addNewFaqClick = () => {
    if (currentUser.isProvider) {
      setFaqModalMode('create');
      setShowFaqModal(!showFaqModal);
    } else {
      setPopNotice('Only a provider can submit a FAQ');
    }
  };

  const fetchProviderPreferredDetails = async () => {
    if (currentUser.provider) {
      const providerDetails = await fetchProviderPreferredInfo(
        currentUser.provider.id
      );
      setProviderInfo({ ...providerDetails });
    }
  };

  // Profile Pic Utils
  const loadProfilePic = async (providerId, picType) => {
    // picType = 'cropped' OR 'original'
    const prefix = `profile-pictures/${providerId}-${picType}`;
    try {
      const [fileObject] = await getFileReq(prefix);
      if (fileObject) {
        setProfileImg(fileObject);
        return true;
      } else {
        // profile picture haven't yet been uploaded
        return false;
      }
    } catch (error) {
      console.error('Error fetching pic from S3:', error);
    }
  };

  const inputPicCallBack = filesObject => {
    [filesObject] = filesObject;
    if (filesObject < 0 && filesObject >= -2) {
      const notice =
        filesObject === -1
          ? 'Max file size is 0.75MB'
          : 'Please use a file of type .jpg or .jpeg';
      setPopNotice(notice);
      return;
    }
    const { fileType, dataUrl } = filesObject;
    setProfileImg({ fileType, dataUrl });
    setCropModal(true);
  };

  const uploadProfilePic = async (imgDataUrl, picType) => {
    const prefix = `profile-pictures/${currentUser.provider.id}-${picType}`;
    await setFileReq(prefix, imgDataUrl);
    updateProvider({ id: currentUser.provider.id, imageUrl: prefix });
  };

  const onEditCrop = async () => {
    const foundPic = await loadProfilePic(currentUser.provider.id, 'original');
    if (foundPic) {
      setCrop({ ...crop, width: 100, height: 100, x: 0, y: 0 });
      setCropModal(true);
    } else {
      setPopNotice('Please upload picture first');
    }
  };

  const onEditInfo = () => {
    setEditProviderConsult(true);
  };

  const updateProviderConsult = async params => {
    await api.updateConsultOptForProvider(params);
    setEditProviderConsult(false);
  };

  const inputEl = useRef(null);
  const onAddNewProfilePic = () => {
    setCrop({ ...crop, width: 100, height: 100, x: 0, y: 0 });
    inputEl.current.click();
  };

  const onCropChange = crop => {
    /* 
     The below "if" is used to solve an unclear behaviour:
     clicking the croping window creates a crop of size 0 that leads to continuous calls to onChange.
    */

    if (crop.height * crop.width !== 0) {
      setCrop(crop);
    }
  };

  const NEW_IMG_TYPE = 'jpeg';

  const onFinishCrop = async () => {
    await uploadProfilePic(profileImg.dataUrl, 'original');
    const newImgDataUrl = await makeCroppedImg(cropImg, crop);
    await uploadProfilePic(newImgDataUrl, 'cropped');
    setProfileImg({ fileType: NEW_IMG_TYPE, dataUrl: newImgDataUrl });
    setCropModal(false);
  };

  const makeCroppedImg = (img, crop) => {
    const canvas = document.createElement('canvas');
    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      img,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
    const newImgDataUrl = canvas.toDataURL('image/' + NEW_IMG_TYPE);
    return newImgDataUrl;
  };

  return providerInUrl ? (
    <>
      <Grid container classes={{ container: container }}>
        <Grid item xs={12} className="paddingZero">
          <Typography variant="h2" className={headerText}>
            My Provider Profile
          </Typography>
          <Typography>
            {!providerInUrl.providerUrl
              ? `Your profile is not yet live.`
              : `Your profile is live on https://qwell.com${
                  providerInUrl.providerUrl
                }`}
          </Typography>
          <Card className={cardSection}>
            <Typography>
              <CardHeader title="Recent Reviews" />
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom="true">
                      Reviews cannot be edited.
                    </Typography>
                    {providerInUrl && (
                      <ReviewsProfileComponent provider={providerInUrl} />
                    )}
                  </CardContent>
                </AccordionSummary>
              </Accordion>
            </Typography>
          </Card>

          <Card className={cardSection}>
            <Typography>
              <CardHeader title="Locations" />
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom="true">
                      Locations can be edited by going to the My Practice tab.
                    </Typography>
                    {providerInUrl && (
                      <LocationsProfileComponent provider={providerInUrl} />
                    )}
                  </CardContent>
                </AccordionSummary>
              </Accordion>
            </Typography>
          </Card>

          <Card className={cardSection}>
            <Typography>
              <Grid justifyContent="right">
                <CardHeader title="About" />
              </Grid>
              <Button
                onClick={() => {
                  setOpenEditModal({ bool: true, section: 'about' });
                }}
              >
                Edit
              </Button>
              <Button
                onClick={() => {
                  setOpenInsertModal({ bool: true, section: 'about' });
                }}
              >
                Insert new content
              </Button>

              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className="fullWidth"
                >
                  <CardContent className="fullWidthSub">
                    {providersContents && (
                      <ContentProfileComponent
                        currentSection={'about'}
                        providersContents={providersContents}
                      />
                    )}
                  </CardContent>
                </AccordionSummary>
              </Accordion>
            </Typography>
          </Card>
          <Card className={cardSection}>
            <Typography>
              <Grid justifyContent="right">
                <CardHeader title="Provider Consult option for Patient" />
              </Grid>
              <Button onClick={onEditInfo}> Edit</Button>
              <CardContent className={columnRadSec}>
                <FormControl
                  component="fieldset"
                  variant="filled"
                  className={input}
                >
                  <FormLabel component="legend">
                    1) Choose Preferred Patient Age for booking appointment
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Preferred Patient Age"
                    name="preferredAge"
                    value={providerInfo && providerInfo.preferredAge}
                    className="cursorNotAllowed"
                  >
                    {providerInfo && providerInfo.preferredAge == 'all' ? (
                      <div className="radio-d-none">
                        <CheckCircleIcon />
                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="All"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    {providerInfo && providerInfo.preferredAge == 'below_18' ? (
                      <div className="radio-d-none">
                        <CheckCircleIcon />
                        <FormControlLabel
                          value="below_18"
                          control={<Radio />}
                          label="Below 18+"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    {providerInfo && providerInfo.preferredAge == 'above_18' ? (
                      <div className="radio-d-none">
                        <CheckCircleIcon />
                        <FormControlLabel
                          value="above_18"
                          control={<Radio />}
                          label="Above 18+"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </RadioGroup>
                </FormControl>
                <FormControl
                  component="fieldset"
                  variant="filled"
                  className={input}
                >
                  <FormLabel component="legend">
                    2) Choose Preferred Patient Gender for booking appointment
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Preferred Patient Gender"
                    name="preferredGender"
                    value={providerInfo && providerInfo.preferredGender}
                    className="cursorNotAllowed"
                  >
                    {providerInfo && providerInfo.preferredGender == 'all' ? (
                      <div className="radio-d-none">
                        <CheckCircleIcon />
                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="All"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    {providerInfo &&
                    providerInfo.preferredGender == 'female' ? (
                      <div className="radio-d-none">
                        <CheckCircleIcon />
                        <FormControlLabel
                          value="female"
                          control={<Radio />}
                          label="Female"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    {providerInfo && providerInfo.preferredGender == 'male' ? (
                      <div className="radio-d-none">
                        <CheckCircleIcon />
                        <FormControlLabel
                          value="male"
                          control={<Radio />}
                          label="Male"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </Typography>
          </Card>
          <Card className={cardSection}>
            <Typography>
              <Grid justifyContent="right">
                <CardHeader title="Profile Picture" />
              </Grid>

              <Button onClick={onEditCrop}> Edit</Button>

              <Button onClick={onAddNewProfilePic}> Upload pic</Button>

              <input
                className={hidden}
                ref={inputEl}
                type="file"
                accept=".jpg"
                onChange={event =>
                  fileSelectHandler(
                    event.target.files,
                    inputPicCallBack,
                    ['jpg', 'jpeg'],
                    1048576 * 0.75 // 1048576 bytes = 1MB
                  )
                }
                /* opening the same named file twice will not trigger an onChange event.
              The solution is the below use of onClick. */

                onClick={e => (e.target.value = null)}
              />
              <CardContent>
                {currentUser.provider && (
                  <Avatar
                    providerId={currentUser.provider.id}
                    refreshImgHook={profileImg}
                  />
                )}
              </CardContent>
            </Typography>
          </Card>

          <Card className={cardSection}>
            <Typography>
              <CardHeader title="Specialties" />
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom="true">
                      Specialties can be edited by going to the My Practice tab.
                    </Typography>
                    {providerInUrl && (
                      <SpecialtiesProfileComponent provider={providerInUrl} />
                    )}
                  </CardContent>
                </AccordionSummary>
              </Accordion>
            </Typography>
          </Card>

          <Card className={cardSection}>
            <Typography>
              <Grid justifyContent="right">
                <CardHeader title="Credentials-Research" />
              </Grid>
              <Button
                onClick={() => {
                  setOpenEditModal({
                    bool: true,
                    section: 'credentials-research',
                  });
                }}
              >
                Edit
              </Button>
              <Button
                onClick={() => {
                  setOpenInsertModal({
                    bool: true,
                    section: 'credentials-research',
                  });
                }}
              >
                Insert new content
              </Button>

              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <CardContent>
                    {providersContents && (
                      <ContentProfileComponent
                        currentSection={'credentials-research'}
                        providersContents={providersContents}
                      />
                    )}
                  </CardContent>
                </AccordionSummary>
              </Accordion>
            </Typography>
          </Card>

          <Card className={cardSection}>
            <Typography>
              <CardHeader title="Accepted Insurances" />
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom="true">
                      Insurances can be edited by going to the My Practice tab.
                    </Typography>
                    {providerInUrl && (
                      <InsurancesProfileComponent provider={providerInUrl} />
                    )}
                  </CardContent>
                </AccordionSummary>
              </Accordion>
            </Typography>
          </Card>

          <Card className={cardSection}>
            <Typography>
              <Grid justifyContent="right">
                <CardHeader title="Frequently Asked Questions" />
              </Grid>
              <Button className={newFaqButton} onClick={addNewFaqClick}>
                Add New FAQ
              </Button>
              <CardContent className={fullWidth}>
                {providersContents && (
                  <FAQsList
                    providerFaqs={providerFaqs}
                    setProviderFaqs={setProviderFaqs}
                    setFaqModalMode={setFaqModalMode}
                    setEditFaqFaqId={setEditFaqFaqId}
                    setShowFaqModal={setShowFaqModal}
                  />
                )}
              </CardContent>
            </Typography>
          </Card>
        </Grid>
        {editProviderConsult && (
          <ProviderConsultOptionInsert
            provider={providerInfo}
            open={editProviderConsult}
            updateProviderInfo={updateProviderConsult}
            onClose={() => {
              setEditProviderConsult(false);
            }}
          />
        )}
        <ProfileEditModal
          provider={providerInUrl}
          providersContents={providersContents}
          setOpenEditModal={setOpenEditModal}
          setProvidersContents={setProvidersContents}
          openEditModal={openEditModal}
          open={openEditModal.bool}
          availableSections={availableSections}
          onClose={() => {
            setOpenEditModal(false);
          }}
        />
        <ProfileInsertModal
          provider={providerInUrl}
          availableSections={availableSections}
          availableCategories={availableCategories}
          availableCategoriesForCredentialsResearch={availableCategoriesForCredentialsResearch}
          setOpenInsertModal={setOpenInsertModal}
          openInsertModal={openInsertModal}
          open={openInsertModal.bool}
          onClose={() => {
            setOpenInsertModal(false);
          }}
        />
      </Grid>

      {showFaqModal && (
        <FAQcreatOrEditeModal
          open={showFaqModal}
          mode={FaqModalMode}
          currentUser={currentUser}
          setProviderFaqs={setProviderFaqs}
          providerFaqs={providerFaqs}
          editFaqFaqId={editFaqFaqId}
          onClose={() => setShowFaqModal(false)}
        />
      )}

      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={() => setPopNotice('')}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}

      {cropModal && (
        <CropModal
          open={cropModal}
          onClose={() => setCropModal(false)}
          image={profileImg}
          crop={crop}
          onImageLoaded={setCropImg}
          onCropChange={onCropChange}
          onDone={onFinishCrop}
        />
      )}
    </>
  ) : (
    'Your profile is not yet set up. Please contact us if you are seeing this message.'
  );
}

const styles = () => ({
  cardSection: {
    margin: '2em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '1.2em',
    color: '#1C1C1C',
  },
  container: {
    padding: '3em',
  },
  fullWidth: {
    width: '100%',
  },
  newFaqButton: {
    marginLeft: '10px',
  },
  hidden: {
    display: 'none',
  },
  input: {
    margin: '0.5em 0',
  },
  columnRadSec: {
    borderTop: '1px solid #c4c4c4',
    display: 'flex',
    flexDirection: 'column',
  },
});

export default withStyles(styles)(ProviderProfileMain);
